import { Room } from './Room';

export interface Role {
  id: number;
  name: string;
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  birthDate: string;
  state: string;
  address?: UserAddress;
  email?: string;
  chloeAccess?: boolean;
  isPediatric?: boolean;
  rewardPoint: number;
  referralCode: string;
  rooms?: Room[];
  roles?: Role[];
  unreadMessageCount: number;
  timeZone?: string;
  fitbitAccessToken?: string;
  garminConfig?: GarminConfig;
  ouraAccessToken?: string;
  phoneNumber?: string;
  phoneNumberCode?: string;
  notifyForMessages: boolean;
  notifyForStudy: boolean;
  notifyForParticipantsActivities: boolean;
  thumbnailUrl?: string;
  mediumUrl?: string;
  largeUrl?: string;
  isPasswordSet?: boolean;
  enableExperimentZone?: boolean;
  unitSystem: UserUnitSystem;
  biologicalSex: UserBiologicalSex;
}

export interface UserDeviceDto {
  utcOffset: number;
  deviceIdentifier: string;
  expoPushToken?: string;
  isDevice: boolean;
  osName: string | null;
  osVersion: string | null;
  appVersion: string;
  appBuild: number;
  deviceName: string | null;
  manufacturer: string | null;
  modelName: string | null;
  model: string | null;
  deviceYearClass: number | null;
}

export interface UserAddress {
  line1: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export interface GarminConfig {
  accessToken: string;
  accessTokenSecret: string;
}

export enum UserUnitSystem {
  Imperial = 'Imperial',
  Metric = 'Metric'
}

export enum UserBiologicalSex {
  Female = 'Female',
  Male = 'Male',
  Intersex = 'Intersex'
}

export enum ParticipantLarRelationshipType {
  Father = 'Father',
  Mother = 'Mother',
  AdoptiveParent = 'Parent (Adoptive)',
  StepParent = 'Parent (Step)',
  LegalGuardian = 'Legal Guardian',
  LegalCustodian = 'Legal Custodian',
  FosterParent = 'Foster Parent',
  HealthcarePowerOfAttorney = 'Power of Attorney (Healthcare)',
  Other = 'Other LAR'
}
